var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 144,
    viewBox: "0 0 151 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.45 71.5982H150.046L100.45 0.000144958H50.8541L100.45 71.5982Z",
    fill: "#38B2AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6569 71.5982H0.0607853L49.6569 0.000144958H99.2531L49.6569 71.5982Z",
    fill: "#4FD1C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.455 143.198L100.455 71.6002L150.051 71.6002L150.051 143.198L100.455 143.198Z",
    fill: "#B2F5EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0521249 143.198L0.0521242 71.6002L49.6483 71.6002L49.6483 143.198L0.0521249 143.198Z",
    fill: "#B2F5EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo_only.46543858880f6a4fd070a140339da9bc.svg";
export { ForwardRef as ReactComponent };